<div class="td-wb-list-item">
    <ng-content select="td-wb-list-item-label" />
    <ng-content select="td-wb-list-item-value" />
</div>
<ng-content />
